import SvgHoverArrowRight from '@img/icons/hover-arrow-right.svg';
import React from 'react';
import { ProfilesStyles as S } from './Profiles.styles';
const Profiles = ({ groups, id }) => {
    return (React.createElement(S.Container, { id: id, innerWidth: "narrow" }, groups &&
        groups.map((group, index) => (React.createElement(S.Group, { key: `group-${index}` },
            React.createElement(S.GroupName, null, group.name),
            group.people && (React.createElement(S.People, null, group.people.map((person, index) => (React.createElement(S.Person, { key: `person-${index}` },
                person.profileUrl ? (React.createElement(S.ProfileUrl, { href: person.profileUrl, styleType: "text", title: person.name, addon: React.createElement(SvgHoverArrowRight, null), buttonSize: "small" }, person.name)) : (person.name),
                person.jobTitle && React.createElement(S.JobTitle, null, person.jobTitle)))))))))));
};
export default Profiles;
